import { Badge } from "react-bootstrap";
import { useLocalState } from "../../../graphql/hooks";
import styles from "./CustomTypeCard.module.scss";

const variantToClass: Record<string, string> = {
    info: styles.leftBorderInfo,
    demoted: styles.leftBorderDemoted,
    purple: styles.leftBorderPurple,
    misc: styles.leftBorderMisc,
    "analytics-alt": styles.leftBorderAnalyticsAlt,
    warning: styles.leftBorderWarning
};

export const leftBorderClass = (variant: string): string =>
    `${styles.coloredLeftBorder} ${variantToClass[variant] ?? ""}`;

// Shared per-card logic: in client mode show a colored left border instead of
// the developer-only type Badge. Returns the className to merge onto the Card
// and a renderTypeBadge() that emits the Badge only in developer mode.
export const useTypeCardVariant = (
    type: string,
    getVariantByType: (type: string) => string,
    badgeClassName = "mx-2"
) => {
    const { developerMode } = useLocalState();
    const variant = getVariantByType(type);
    return {
        variant,
        cardClassName: !developerMode ? leftBorderClass(variant) : "",
        renderTypeBadge: () =>
            developerMode ? (
                <Badge className={badgeClassName} bg={variant}>
                    {type}
                </Badge>
            ) : null
    };
};
